import parseImage from './image'
import parseLink from './link'

export default function parseArticleTip(entry) {
    const { title } = entry.fields
    const description = entry.fields.content
    const ctaLink = entry.fields.ctaLink ? parseLink(entry.fields.ctaLink) : null
    const captionLink = entry.fields.captionLink ? parseLink(entry.fields.captionLink) : null
    const backgroundImage = entry.fields.backgroundImage
        ? parseImage(entry.fields.backgroundImage)
        : null
    return {
        title,
        description,
        ctaLink,
        captionLink,
        backgroundImage,
    }
}
